// CANONICAL COPY (GH #7115). src/constants/obligations/obl-independent-review.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-independent-review',
  title: 'Schedule independent review / audit',
  description:
    'Plan and execute an independent review of the ISMS. This may be an internal audit or an external assessment.',
  category: 'compliance',
  scfIds: ['SCF-AUD-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'manual-attestation',
      description: 'Confirm the independent review / audit was actually planned and executed',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
